export const IMAGE_URL = "https://image.tmdb.org/t/p/original";
export const POSTER_URL = "https://image.tmdb.org/t/p/w500";

export const TRENDING_URL = "/trending/movie/day";
export const POPULAR_URL = "/movie/popular";
export const TOP_RATED_URL = "/movie/top_rated";
export const NOW_PLAYING_URL = "/movie/now_playing";
